module.exports = __webpack_public_path__ + "static/media/DP_Timeless_Piazza_Bordeaux.681dc8e3.png";